





















import { Component, Vue, Emit, Inject } from 'vue-property-decorator'
import { getSearchRank } from '../../search-service' //请求接口

@Component({})
export default class SearchRank extends Vue {
  rank: any[] = []

  async created() {
    this.rank = await getSearchRank()
  }

  get topWeight() {
    return (top: number) => {
      if (top < 3) {
        return 'bold'
      }
      return 'normal'
    }
  }

  get topColor() {
    return (top: number) => {
      if (top > 2) {
        return '#999'
      } else if (top > 1) {
        return '#FFB320'
      } else if (top > 0) {
        return '#FF8800'
      }
      return '#FF5900'
    }
  }

  @Inject({ from: 'useRankEP', default: null }) useRankEP!: any
  useRankExposure(item: any) {
    return this.useRankEP && this.useRankEP({ link: item.link, name: item.title })
  }
  @Emit('useRank')
  useRank(item:any) {
    location.href = item.link
  }
}
